import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Box,
  Typography,
  Container,
  Paper,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../assests/EasyTrade2.png";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const theme = createTheme({
  palette: {
    primary: { main: "#2db7e8" },
    background: { default: "#e3f2fd" },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
});

export function Login() {
  const [register_data, setRegisterData] = useState({});
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRegisterData({ ...register_data, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    if (!register_data?.email) {
      toast.warn("Please fill email");
      return;
    }
    if (!register_data?.password) {
      toast.warn("Please fill password");
      return;
    }

    if (data.get("email") === "admin@cts.et" && data.get("password") == 12345) {
      toast.success("Login Successfully");
      setTimeout(() => navigate("/home"), 1000);
    } else {
      toast.error("Wrong Credentials");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CssBaseline />
        <Paper
          elevation={6}
          sx={{
            p: 4,
            borderRadius: 4,
            textAlign: "center",
            width: "100%",
            background: "linear-gradient(145deg, #ffffff, #d7effa)",
            boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
          }}
        >
          <img src={logo} alt="logo" style={{ width: 180, marginBottom: 20 }} />
          <Avatar
            sx={{
              m: "0 auto 10px",
              bgcolor: "#2db7e8",
              width: 56,
              height: 56,
            }}
          >
            <LockOutlinedIcon />
          </Avatar>

          <Typography variant="h5" fontWeight="600" gutterBottom>
            Welcome Back 👋
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 2, fontSize: 13 }}
          >
            Please login to continue to EasyTrade
          </Typography>

          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              margin="normal"
              fullWidth
              id="email"
              label="User ID"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={handleChange}
              InputProps={{
                sx: { borderRadius: 2 },
              }}
            />

            <TextField
              margin="normal"
              fullWidth
              name="password"
              label="Password"
              type={showPassword ? "text" : "password"}
              id="password"
              onChange={handleChange}
              autoComplete="current-password"
              InputProps={{
                sx: { borderRadius: 2 },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      sx={{
                        color: "#2db7e8", // brand blue for icon
                        "&:hover": { backgroundColor: "rgba(45,183,232,0.1)" },
                      }}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                py: 1.4,
                fontWeight: "bold",
                textTransform: "none",
                fontSize: "1rem",
                borderRadius: 3,
                boxShadow: "0px 4px 10px rgba(45,183,232,0.4)",
              }}
            >
              Log In
            </Button>
          </Box>

          <Typography variant="caption" color="text.secondary">
            © {new Date().getFullYear()} EasyTrade. All Rights Reserved.
          </Typography>
        </Paper>
        <ToastContainer position="bottom-center" />
      </Container>
    </ThemeProvider>
  );
}
